import { showToast } from '@/features/toasts/toastsSlice';
import { IconButton } from '@/lib';
import { DistributionChannelConnector } from '@/models/distributionChannels';
import { IModalContentProps } from '@/models/modals';
import { ToastType } from '@/models/toast';
import { WorkspaceId } from '@/models/workspace';
import { useAppDispatch } from '@/reducers';
import { useDeauthenticateConnectorMutation } from '@/services/endpoints/distributionChannels';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TrashIcon } from '@/lib/Icons';

type DeauthenticateConntectorModalProps = {
  workspaceId: WorkspaceId;
  connector: DistributionChannelConnector;
};

export const DeauthenticateConnectorModal: FC<DeauthenticateConntectorModalProps & IModalContentProps> = ({ connector, workspaceId, closeModal }) => {
  const { t } = useTranslation('destinations');
  const [deauthenticateConnector, { isLoading, isSuccess }] = useDeauthenticateConnectorMutation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isSuccess) {
      closeModal();
      dispatch(
        showToast({
          type: ToastType.SUCCESS,
          title: t('catalog.deleteModal.toast_title'),
          message: t('catalog.deleteModal.toast_message', { connector: connector.name }),
        })
      );
    }
  }, [isSuccess]);

  return (
    <div className='flex flex-col items-start p-8'>
      <h1 className='mb-5 text-lg font-semibold text-black-100'>{t('catalog.deleteModal.title')}</h1>
      <p className='mb-5 text-base'>{t('catalog.deleteModal.subtitle', { connector: connector.name })}</p>
      <IconButton
        text={t('catalog.deleteModal.button_title')}
        leadingIcon={<TrashIcon />}
        intent='primary'
        onClick={() => deauthenticateConnector({ workspaceId, connectorName: connector.name, integrationPartner: connector.integrationPartner })}
        isLoading={isLoading}
        disabled={isLoading}
        className='self-center'
      ></IconButton>
    </div>
  );
};
